import type {TrackingContext} from './trackingTypes';

type SidebarMenuTrackingContext = {
  menu_name: null | string;
  procedure: null | string;
  thematique: null | string;
};

type UserTrackingContext = {
  domaine: null | string;
  firm_name: null | string;
  user_id: null | string;
};

const EMPTY_SIDEBAR_CONTEXT: SidebarMenuTrackingContext = {
  menu_name: null,
  procedure: null,
  thematique: null,
};

const EMPTY_USER_CONTEXT: UserTrackingContext = {
  domaine: null,
  firm_name: null,
  user_id: null,
};

let lastKnownMenuName: null | string = null;
let lastKnownProcedure: null | string = null;
let lastKnownThematique: null | string = null;
let sidebarMenuTrackingContext = EMPTY_SIDEBAR_CONTEXT;
let userTrackingContext = EMPTY_USER_CONTEXT;

export function getTrackingContext(): TrackingContext {
  const isAuthenticated = userTrackingContext.user_id !== null;
  const menuName = sidebarMenuTrackingContext.menu_name
    ?? (isAuthenticated ? lastKnownMenuName : null);
  const procedure = sidebarMenuTrackingContext.procedure
    ?? (isAuthenticated ? lastKnownProcedure : null);
  const thematique = sidebarMenuTrackingContext.thematique
    ?? (isAuthenticated ? lastKnownThematique : null);

  return {
    ...userTrackingContext,
    ...sidebarMenuTrackingContext,
    menu_name: menuName,
    procedure,
    thematique,
  };
}

export function setSidebarMenuTrackingContext(
  context: SidebarMenuTrackingContext,
): void {
  if (context.menu_name !== null) {
    lastKnownMenuName = context.menu_name;
  }

  if (context.procedure !== null) {
    lastKnownProcedure = context.procedure;
  }

  if (context.thematique !== null) {
    lastKnownThematique = context.thematique;
  }

  sidebarMenuTrackingContext = context;
}

export function setUserTrackingContext(context: UserTrackingContext): void {
  userTrackingContext = context;

  if (context.user_id === null) {
    lastKnownMenuName = null;
    lastKnownProcedure = null;
    lastKnownThematique = null;
  }
}
